import { gql } from '@apollo/client';

export const USERS = gql`
query Users {
  users {
    users {
      id
      firstName
      lastName
    }
  }
}
`;

export const GET_USER = gql`
  query User($userId: Int) {
    user(id: $userId) {
      id
      firstName
      lastName
      email
      googleId
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      displayTour
      lastLoginAt
    }
  }
`;

export const GET_USERS_PROJECT_SKILL = gql`
query GetUserProjectAllocationData($userId: Int!, $profileId: Int!) {
  getUserProjectAllocationData(userId: $userId, profileId: $profileId) {
    projectId
    projectName
    projectDuration
    skillName
    allocationPercent
  }
}
`;

export const GET_USERS_TIMEBLOCK = gql`
query GetUsersTimeBlock($userId: Int!) {
  getUsersTimeBlock(userId: $userId) {
    id
    user_id
    start_date
    end_date
  }
}
`;

export const DELETE_TIME_BLOCK = gql`
mutation DeleteTimeBlock($input: deleteTimeBlockInput!) {
  deleteTimeBlock(input: $input)
}
`;

export const ALLOCATION_PERCENT = gql`
mutation UpdateAllocationPercent($input: UpdateAllocationPercentInput) {
  updateAllocationPercent(input: $input)
}
`;

export const ADD_TIME_BLOCK = gql`
mutation AddTimeBlock($input: TimeBlockInput!) {
  createTimeBlock(input: $input) {
    end_date
    id
    start_date
    user_id
  }
}
`;

export const ADD_USER = gql`
mutation AddUser($token: String!) {
  addUser(token: $token) {
    id
    firstName
    lastName
    email
    googleId
    isActive
    createdAt
    lastLoginAt
    updatedAt
    createdBy
    updatedBy
    displayTour
  }
}
`;

export const LOGIN_USER = gql`
query UserLogin($code: String!) {
  loginUser(code: $code) {
    authToken {
      accessToken
      refreshToken
    }
    userResponse {
      id
      firstName
      lastName
      email
      googleId
      isActive
      createdAt
      lastLoginAt
      updatedAt
      createdBy
      updatedBy
      displayTour
    }
    googleToken {
      token
      refresh_token
    }
  }
}
`;

export const SEND_OTP_EMAIL = gql`
mutation SendOtpMail($email: String!) {
  generateLoginOtp(email: $email) {
    message
  }
}
`;

export const VERIFY_LOGIN_OTP = gql`
mutation VerifyLoginOtp($email: String!, $code: String!) {
  verifyLoginOtp(email: $email, code: $code) {
    authToken {
      accessToken
      refreshToken
    }
    userResponse {
      id
      firstName
      lastName
      email
      googleId
      isActive
      createdAt
      lastLoginAt
      updatedAt
      createdBy
      updatedBy
      displayTour
    }
  }
}
`;

export const LOGOUT_USER = gql`
  mutation LogoutUser($userId: Int) {
    logoutUser(userId: $userId) {
      message
    }
  }
`;
